import React from "react";
import BrandingItem from "./branding-item.tsx";
import DrawGame from "./draw-game.tsx";

// const BlankBg = require("../images/blank.png");

const BoomerangImgBg = require("../images/boomerang/boomerang.png");
const BoomerangImgLogo = require("../images/boomerang/boomerang-logo.png");
const BoomerangImgButton = require("../images/boomerang/boomerang-button.png");

const PG9ImgBg = require("../images/pg9/pg9.png");
const PG9ImgLogo = require("../images/pg9/pg9-logo.png");
const PG9ImgButton = require("../images/pg9/pg9-button.png");

const H4winImgBg = require("../images/h4win/h4win.png");
const H4winImgLogo = require("../images/h4win/h4win-logo.png");
const H4winImgButton = require("../images/h4win/h4win-button.png");

const R4winImgBg = require("../images/rr4win/rr4win.png");
const R4winImgLogo = require("../images/rr4win/rr4win-logo.png");
const R4winImgButton = require("../images/rr4win/rr4win-button.png");

const DrawImgBg = require("../images/draw/draw-bg.png");
const DrawImgLogo = require("../images/draw/draw-logo.png");
const DrawImgButton = require("../images/draw/draw-button.png");

const StayTunedBg = require("../images/stay-tuned/stay-tuned.png");

export default function BrandingList({ isMobile }: { isMobile: boolean }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        width: "100%",
        gap: "20px",
      }}
    >
      <DrawGame
        isMobile={isMobile}
        button={DrawImgButton}
        logo={DrawImgLogo}
        background={DrawImgBg}
      />
      <BrandingItem
        link="https://boomerangbetscasino.net/RF36A7259A6"
        isMobile={isMobile}
        logo={BoomerangImgLogo}
        button={BoomerangImgButton}
        background={BoomerangImgBg}
        brand="boomerang"
      />
      <BrandingItem
        link="https://h4winau.net/RF266121065"
        isMobile={isMobile}
        logo={H4winImgLogo}
        button={H4winImgButton}
        background={H4winImgBg}
        brand="h4win"
      />
      <BrandingItem
        link="https://rr4winaus.org/RF266121821"
        isMobile={isMobile}
        logo={R4winImgLogo}
        button={R4winImgButton}
        background={R4winImgBg}
        brand="r4win"
      />
      <BrandingItem
        link="https://pg9au.vip/RF9960A59"
        isMobile={isMobile}
        logo={PG9ImgLogo}
        button={PG9ImgButton}
        background={PG9ImgBg}
        brand="pg9"
      />
      <BrandingItem
        link="#"
        isMobile={isMobile}
        logo=""
        button=""
        background={StayTunedBg}
        brand="stay-tuned"
      />
      {/* <BrandingItem isMobile background={BlankBg} brand="upcoming" /> */}
    </div>
  );
}
